<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Meldebox</h1>

    <form @submit.prevent="store">
      <div v-if="step==1" class="bg-gray-300 p-8">
        <p class="mb-3">Hallo liebe Kollegin, lieber Kollege,</p>
        <p class="mb-3">
          Sie sind auf diese Seite gekommen, weil Sie uns etwas anonym mitteilen möchten.
        </p>
        <p class="mb-3">
          Wir versichern Ihnen, dass diese Mitteilung nicht auf Sie zurückzuverfolgen ist. Die Seite liegt bei einem externen Anbieter und nicht auf unserem Provider, so dass wir ausschließen können, dass auch mit viel Mühe Ihre Identität erkannt wird. Selbstverständlich können Sie Sich auch immer vertrauensvoll an unsere Geschäftsführung wenden, die Ihnen zuhört und gemeinsam mit Ihnen versuchen wird, das Problem zu lösen, ohne dass Sie dadurch einen Schaden nehmen. Aber weil wir denken, dass das nicht jeder tun möchte, gibt es jetzt diese neue Möglichkeit.
        </p>
        <p class="mb-3">
          <strong>Wählen Sie im ersten Schritt aus, wie Sie Ihre Meldung angeben möchten.</strong>
        </p>
        <div class="mt-8">
          <label><input v-model="form.anonym" type="radio" :value="true" class="mb-3" /> Ich möchte meine Meldung komplett anonym abgeben</label><br />
          <label><input v-model="form.anonym" type="radio" :value="false" class="mb-3" /> Ich möchte meinen Hinweis vertraulich angeben</label>

          <div v-if="form.anonym == false" class="my-8">
            <text-input v-model="form.vorname" :error="form.errors.vorname" class="pb-8 pr-6 w-full" label="Vorname" />
            <text-input v-model="form.nachname" :error="form.errors.nachname" class="pb-8 pr-6 w-full" label="Nachname" />
            <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full" label="E-Mail Adresse" />
          </div>
        </div>
        <div class="mt-16">
          <loading-button class="btn-indigo" @click="step++">weiter</loading-button>
        </div>
      </div>

      <div v-if="step==2" class="bg-gray-300 p-8">
        <p class="mb-3">
          <strong>Jetzt bitten wir Sie, den Vorfall zu schildern.</strong>
        </p>
        <ul class="ml-4 mb-3 list-disc">
          <li class="mb-2">Was genau ist passiert?</li>
          <li class="mb-2">Wann und wo ist es passiert?</li>
          <li class="mb-2">Sind Sie selbst betroffen oder nur Zeuge?</li>
        </ul>
        <p class="mb-3">
          Achten Sie bei der Schilderung darauf, dass wir keine Rückschlüsse auf Ihre Person ziehen können.
        </p>

        <div class="mt-8">
          <select-input v-model="form.category_id" :error="form.errors.category_id" class="pb-8 pr-6 w-full" label="Zu welchem Thema wollen Sie eine Meldung machen?">
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.text }}</option>
          </select-input>
          <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full" label="Bitte geben Sie eine Überschrift an" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Bitte beschreiben Sie den Sachverhalt" />
        </div>

        <div class="mt-16 flex">
          <loading-button class="btn-indigo mr-4" @click="step--">zurück</loading-button>
          <loading-button class="btn-indigo" @click="step++">weiter</loading-button>
        </div>
      </div>
      <div v-if="step==3" class="bg-gray-300 p-8">
        <p class="mb-3">Wenn Sie noch Fotos gemacht haben oder uns Dokumente liefern möchten, können Sie diese hier hochladen. Sollten es mehrere Dateien sein, dann laden Sie bitte eine komplette ZIP-Datei hoch.</p>

        <div class="mt-8">
          <file-input v-model="form.file" :error="form.errors.file" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="*" label="Dateiupload" />
        </div>

        <div class="mt-16 flex">
          <loading-button class="btn-indigo mr-4" @click="step--">zurück</loading-button>
          <loading-button class="btn-indigo" @click="step++">weiter</loading-button>
        </div>
      </div>
      <div v-if="step==4" class="bg-gray-300 p-8">
        <p class="mb-3"><strong>Zusammenfassung Ihrer Meldung</strong></p>
        <p class="mb-3">Kontrollieren Sie bitte nochmals ob alles korrekt ist. Wenn alles stimmt dann können Sie die Meldung absenden. Sollten Sie noch was ändern wollen, dann können Sie mit "zurück" wieder zur entsprechenden Eingabe zurück gehen.</p>

        <table class="table-auto w-full p-6">
          <tbody>
            <tr class="border-b">
              <td class="px-3 py-2">Kategorie</td>
              <td class="px-3 py-2">{{ findCategory(form.category_id) }}</td>
            </tr>
            <tr class="border-b">
              <td class="px-3 py-2">Titel</td>
              <td class="px-3 py-2">{{ form.title }}</td>
            </tr>
            <tr class="border-b">
              <td class="px-3 py-2">Meldung</td>
              <td class="px-3 py-2"><pre>{{ form.description }}</pre></td>
            </tr>
          </tbody>
        </table>

        <div class="mt-16 flex">
          <loading-button class="btn-indigo mr-4" @click="step--">zurück</loading-button>
          <loading-button class="btn-indigo" type="supmit">Jetzt absenden!</loading-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout2'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    FileInput,
  },
  layout: Layout,
  props: {
    status: Array,
    categories: Array,
  },
  data() {
    return {
      step: 1,
      form: this.$inertia.form({
        category_id: 1,
        status_id: 1,
        title: '',
        anonym: true,
        vorname: '',
        nachname: '',
        email: '',
        description: '',
        file: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/meldung')
    },
    findCategory(category_id) {
      console.log(category_id)
      console.log(this.categories)
      const cat = (this.categories.find(c => {
        if(c.id == category_id)
          return c
      }))

      return cat.text
    },
  },
}
</script>

